import { t } from "i18next";
import { SkeletonTheme } from "react-loading-skeleton";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaginationState } from "@tanstack/react-table";
import { useAppSelector } from "../../shared/hook";
import Pagination from "../../shared/components/Table/Pagination";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import { format } from "date-fns";
import { Tooltip } from "react-tooltip";
import { Field, Form, Formik } from "formik";
import style from "../MainScreen/ChequesList.module.css";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import classNames from "classnames";
import Calendar from "../../shared/Ui/Calendar/Calendar";
import { normalizedLocale } from "../../common/libs/normalizedLocale";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from 'uuid';
import mockAdmin from "../Authorization/utils/mockAdmin";
import { deleteOrder, getOrders, handleCreateDraft } from "../../common/api/ordersApi";
import { log } from "node:console";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";



function OrderList() {
    const [errorModal, setErrorModal] = useState<any>(null);
    const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
    const handleTooltipToggle = (id: number) => {
        setActiveTooltipId((prevId) => (prevId === id ? null : id));
    };
    const role = Cookies.get("role");
    const [cookiesLoaded, setCookiesLoaded] = useState(false);
    const { t, i18n } = useTranslation();
    const [parsedRows, setParsedRows] = useState([])
    const [ntinSelect, setNtinSelect] = useState([])
    const locale = normalizedLocale(i18n.language);
    const [releaseMethods, setReleaseMethods] = useState([]);
    const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState<Date | undefined>(undefined);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
    const [jewelryGroup, setJewelryGroup] = useState<any>([])
    const userData: any = useAppSelector((state) => state.auth.userData);
    const tableDataCookie = JSON.parse(localStorage.getItem('TableData') || 'null');
    const [isDeletOpen, setIsDeletOpen] = useState<any>(null)

    const baseValues = tableDataCookie

    // Если роль admin, добавляем больше товаров
    const extraValues = role == "admin" ? mockAdmin : [];


    const [tableData, setTableData] = useState<any>([]);
    const [pagination, setPagination] = useState<PaginationState>({
        pageIndex: 0,
        pageSize: 10
    });

    // Add this function to get current page data
    const getCurrentPageData = () => {
        const startIndex = pagination.pageIndex * pagination.pageSize;
        const endIndex = startIndex + pagination.pageSize;
        return tableData.slice(startIndex, endIndex);
    };

    // Add this function to calculate total pages
    const getTotalPages = () => {
        return Math.ceil(tableData.length / pagination.pageSize);
    };

    // const [tableData, setTableData] = useState<any>({
    //     values: [
    //         {
    //             id: 3,
    //             name: "Михеева Ирина Анатольевна",
    //             barcode: "1234567890123",
    //             status: "DRAFT",
    //             statusLabel: "Ожидает подтверждения",
    //             adress: "11111",
    //             createdAt: "2024-03-01",
    //             deliveryDate: "2024-03-10",
    //         },
    //         {
    //             id: 2,
    //             name: "Михеева Ирина Анатольевна",
    //             barcode: "9876543210987",
    //             status: "DRAFT",
    //             statusLabel: "Ожидает подтверждения",
    //             adress: "22222",
    //             createdAt: "2024-03-05",
    //             deliveryDate: "2024-03-15",
    //         },
    //         {
    //             id: 1,
    //             name: "Михеева Ирина Анатольевна",
    //             barcode: "1112223334445",
    //             status: "IN_PROCESSING",
    //             statusLabel: "Ожидает подтверждения",
    //             adress: "33333",
    //             createdAt: "2024-03-07",
    //             deliveryDate: "2024-03-20",
    //         },
    //     ],
    //     totalItems: 3,
    //     totalPages: 1,
    // });
    const [isLoading, setIsLoading] = useState(false);
    const pageSize = useAppSelector((state) => state.userSettings.pageSize);
    type PaginationState = {
        pageIndex: number;
        pageSize: number;
    };

    useEffect(() => {
        console.log(123123);

        const fetchOrders = async () => {
            try {
                const data = await getOrders();
                setTableData(data);
            } catch (error) {
                console.error("Ошибка при загрузке заказов:", error);
            }
        };
        console.log('tableData', tableData);

        fetchOrders();
        // console.log("tableData до обновления:", tableData);
        // if (cookiesLoaded) return; // Если уже загрузили, выходим

        // const storedData = JSON.parse(localStorage.getItem('TableData') || 'null');
        // if (!storedData) return;

        // const parsedData = storedData;

        // setTableData((prevData: any) => {
        //     // Проверяем, есть ли уже загруженные данные
        //     const newData = parsedData.filter(
        //         (newItem: any) => !prevData.values?.some((oldItem: any) => oldItem.id === newItem.id)
        //     );

        //     if (newData.length === 0) {
        //         console.log("Данные уже загружены, повторное добавление отменено");
        //         return prevData;
        //     }

        //     return {
        //         ...prevData,
        //         values: [...(prevData.values || []), ...newData], // Добавляем только новые данные
        //         totalItems: (prevData.totalItems || 0) + newData.length, // Увеличиваем количество
        //     };
        // });

        // setCookiesLoaded(true);
    }, [pagination, isDeletOpen]);

    const handleDeleteClick = (index: number) => {
        console.log("del");

    };


    interface StatusType {
        type: string;
        label: string;
    }
    useEffect(() => {
        const clearSelected = (e: any) => {
            if (!e.target.classList.contains("react-tooltip")) {
                setIsFilterOpen(false);
            }
        };
        window.addEventListener("click", clearSelected);

        return () => window.removeEventListener("click", clearSelected);
    }, []);

    const handleCreate = async () => {
        try {
            const data = await handleCreateDraft();
            const id = data.id;
            navigate(`/order/${id}`)
        } catch (error: any) {
            console.error("Ошибка при создании черновика:", error);
            setErrorModal({
                hasError: true,
                errorMessage: error?.response?.data?.message || "Произошла ошибка при создании черновика"
            });
        }
    };





    useEffect(() => {
        onLoad()
    }, [pagination]);

    const debounce = (func: Function, delay: number) => {
        let timeoutId: ReturnType<typeof setTimeout>;
        return (...args: any) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    async function onLoad() {

    }

    const toggleSort = () => {
        const newSortDirection = sort === "ASC" ? "DESC" : "ASC";
        setSort(newSortDirection);
    };

    const calculateItemNumber = (index: any) => {
        return pagination.pageIndex * pagination.pageSize + index + 1;
    };

    const statusTypes: { [key: string]: StatusType } = {
        DRAFT: { type: "test", label: t("Черновик") },
        SENT_TO_CONFIRMATION: {
            type: "test",
            label: t("Ожидает подтверждения"),
        },
        REJECTED: { type: "error", label: t("Отклонен") },
        WAITING_FOR_DELIVERY: { type: "test", label: t("Ожидает доставки") },
        PARTIALLY_DELIVERED: { type: "active", label: t("Частично доставлен") },
        CONFIRMED: { type: "active", label: t("Подтвержден") },
    };

    const renderActions = (
        value: any,
        setErrorModalAction: any,
        navigate: any,
        setAlertOpen?: any,
        setIsCheckOpen?: any,
    ) => {
        const actions = [];
        actions.push({
            title: t("orderList.show"),
            action: () => {
                if (value.status == 'PROCESSED') {
                    navigate("/cheque/" + value?.id)
                }

            }
        });
        return actions;
    };
    const [initialValues, setInitialValues] = useState({
        fiscalDocumentNumber: "",
        kktRegId: '',
        operationType: null,
        status: null,
        refJewelryGroupId: '',
        ntin: null,
        vendor: ''
    });

    return (
        < >
            <ModalComponent
                isOpen={isDeletOpen}
                onClose={() => {
                    setIsDeletOpen(null);
                }}
                content={
                    <div className="w-[600px] bg-white flex flex-col gap-6">
                        <h2 className="text-xl font-semibold text-gray-900">Удалить заказ</h2>
                        <p className="text-gray-700 text-base">
                            Вы уверены, что хотите удалить этот заказ? Это действие нельзя будет отменить.
                        </p>

                    </div>
                }
                customContent={
                    <div className="flex gap-[15px]">
                        <ModalButton
                            type="button"
                            color='grey'
                            onClick={() => {
                                console.log(tableData);
                                setIsDeletOpen(null)
                            }}
                        >
                            Закрыть
                        </ModalButton>
                        <ModalButton
                            type="button"
                            color='mainColor'
                            onClick={() => {
                                console.log("working");

                                deleteOrder(isDeletOpen)
                                setIsDeletOpen(null)
                            }}
                        >
                            Удалить
                        </ModalButton>
                    </div>

                }
            />
            <ModalComponent
                isOpen={errorModal}
                onClose={() => setErrorModal(null)}
                headerContent={<h1 className="text-xl font-semibold text-gray-900">Уведомление</h1>}
                content={
                    <div className="w-[600px] bg-white flex flex-col gap-6">
                        <p className="text-gray-700 text-base">
                            {errorModal?.errorMessage || "Произошла ошибка при создании черновика"}
                        </p>
                    </div>
                }
                customContent={
                    <div className="flex gap-[15px]">
                        <ModalButton
                            type="button"
                            color='grey'
                            onClick={() => setErrorModal(null)}
                        >
                            Закрыть
                        </ModalButton>
                    </div>
                }
            />
            <div className="flex flex-col w-[100%]">

                <div className="flex flex-col w-full">
                    <span className="my-3 text-xl font-semibold">
                        Заявки на поставку товаров
                    </span>
                    {role != "Администратор" && (
                        <div className="bg-white  my-5 p-5 relative rounded-xl shadow-md flex flex-row align-center justify-between">
                            <div className="flex items-center">

                                <button
                                    onClick={handleCreate}
                                    className=" bg-mainColor text-gray-700  font-semibold py-2 px-4 rounded"
                                >
                                    Добавить
                                </button>

                            </div>
                        </div>
                    )
                    }
                    {/* <div className="flex flex-row gap-[20px]">
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsFilterOpen(true);
                                }}
                                className=" bg-green text-white font-semibold py-2 px-4 rounded"
                                data-tooltip-offset={4}
                                data-tooltip-id="filter-type"
                            >
                                {t("mainButtons3.filter")}
                            </button>
                            <button
                                onClick={() => {
                                    setStartDate(undefined);
                                    setEndDate(undefined);
                                    setInitialValues({
                                        fiscalDocumentNumber: '',
                                        kktRegId: '',
                                        operationType: null,
                                        status: null,
                                        refJewelryGroupId: '',
                                        ntin: null,
                                        vendor: ''
                                    })
                                    setPagination((prevValues: PaginationState) => {
                                        return { ...prevValues, pageIndex: 0 };
                                    });
                                }}
                            >
                                <img src="/icons/update.svg" />
                            </button>
                        </div> */}

                    <div className="w-full">
                        <div className="rounded-lg bg-white overflow-auto">
                            <table className="max-w-full w-full leading-normal">
                                <thead className="border-b-2 border-gray-300">
                                    <tr>
                                        <th
                                            className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                            scope="col"
                                        >
                                            №
                                        </th>
                                        <th
                                            className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                            scope="col"
                                        >
                                            Адрес
                                        </th>
                                        <th
                                            className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                            scope="col"
                                        >
                                            Торговая точка
                                        </th>

                                        <th
                                            className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                            scope="col"
                                        >
                                            Статус заявки
                                        </th>
                                        <th
                                            className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                            scope="col"
                                        >
                                            Дата заявки
                                        </th>
                                        <th
                                            className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                            scope="col"
                                        >
                                            Дата поставки
                                        </th>

                                    </tr>
                                </thead>
                                {isLoading ? (
                                    <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                                        <tbody className="font-normal text-center">

                                        </tbody>
                                    </SkeletonTheme>
                                ) : getCurrentPageData()?.length === 0 || !getCurrentPageData() ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan={8} className="text-center py-5">
                                                <div>
                                                    <EmptyListPlaceholderContent
                                                        title={t("Заявки не найдены")}
                                                    // description={t("orderList.noOrdersDescription")}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <tbody className="font-normal text-center">
                                        {getCurrentPageData()?.map((value: any, index: any) => (
                                            <tr
                                                key={`tr-${index}-${value.id}`}
                                                className="cursor-pointer hover:bg-gray-100"
                                                onClick={() => {
                                                    navigate("/order/" + value?.id)
                                                }
                                                }
                                            >
                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                    {calculateItemNumber(index) || "-"}
                                                </td>
                                                <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600 cursor-pointer "
                                                >
                                                    {value?.tradePoint.address || "-"}
                                                </td>
                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                    {value?.tradePoint.name || "-"}
                                                </td>
                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                                                    <div className="flex justify-center">
                                                        <StatusBadge
                                                            type={statusTypes?.[value.status]?.type || "unsaved"}
                                                            fontSize="15px"
                                                            circleSize="8px"
                                                        >
                                                            {statusTypes[value.status]?.label ||
                                                                t("documents_upload.unknownStatus")}
                                                        </StatusBadge>
                                                    </div>
                                                </td>
                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                    {value.createdAt && !isNaN(new Date(value.createdAt).getTime())
                                                        ? format(new Date(value.createdAt), "dd.MM.yyyy HH:mm:ss")
                                                        : '-'}
                                                </td>
                                                <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                    {value.deliveryDate && !isNaN(new Date(value.deliveryDate).getTime())
                                                        ? format(new Date(value.deliveryDate), "dd.MM.yyyy HH:mm:ss")
                                                        : '-'}
                                                </td>
                                                {value.status == "DRAFT" && role == "Пользователь" ? (
                                                    <td className="min-w-[40px] border-b border-gray-200" >
                                                        <div
                                                            className="cursor-pointer"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setIsDeletOpen(value.id);
                                                            }}
                                                        >
                                                            <img
                                                                src="/icons/trash.svg"
                                                                alt="Delete"
                                                                className=""
                                                            ></img>
                                                        </div>
                                                    </td>
                                                ):(
                                                <td className="min-w-[40px] border-b border-gray-200" >
                                                </td>
                                                )}


                                            </tr>
                                        ))}
                                    </tbody>
                                )}
                            </table>
                        </div>
                        <Pagination
                            totalItems={tableData?.length || 0}
                            totalPages={getTotalPages()}
                            pagination={pagination}
                            setPagination={setPagination}
                        />
                    </div>
                    <div className="z-[1000] relative	">
                        {/* <Tooltip
                            isOpen={isFilterOpen}
                            id="filter-type"
                            className={classNames(style.wrapperTooltipFilter, "drop-shadow-2xl")}
                            openOnClick={true}
                            clickable={true}
                            noArrow={true}
                            opacity={1}
                            place={"bottom-end"}
                            afterShow={() => setIsFilterOpen(true)}
                            afterHide={() => setIsFilterOpen(false)}
                        >
                            <div onClick={(e) => e.stopPropagation()}>{renderFilterInputs()}</div>
                        </Tooltip> */}
                    </div>

                </div>

            </div>

        </>
    );
}


export default OrderList;
